import React from 'react'
import PropTypes from 'prop-types'
import { Card, Button, Modal } from 'antd-mobile'

const AddressItemExtra = ({ onEdit, onDelete }) => {
  return <div className={'flex justify-end'}>
    <Button size={'small'} fill={'outline'} onClick={onEdit}>
      <i className={'icon-font icon-edit'}/>
    </Button>&emsp;
    <Button size={'small'} color={'danger'} onClick={onDelete}>
      <i className={'icon-font icon-ashbin'}/>
    </Button>
  </div>
}

class AddressItem extends React.PureComponent {
  static defaultProps = {
    name: '　',
    phone: '　',
    region: '　',
    address: '　',
    email: '　',
    onSelect: function () {console.log('on select')},
    onEdit: function () {console.log('on edit')},
    onDelete: function () {console.log('on delete')}
  }
  static propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    region: PropTypes.string,
    address: PropTypes.string,
    onSelect: PropTypes.func,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func
  }

  render () {
    const {
      name, phone, address, email, region, onSelect
    } = this.props
    return <div onClick={onSelect}>
      <Card className={'m-4'} title={name} extra={phone}>
        <div className={'pt-1 pb-2'}>
          {region} {address}
        </div>
        <div className={'flex justify-between items-center'}>
          <div>{email}</div>
          <div><AddressItemExtra onDelete={this.onDelete} onEdit={this.onEdit}/></div>
        </div>
      </Card>
    </div>
  }

  onEdit = (e) => {
    e.stopPropagation()
    this.props.onEdit(this.props.id)
  }

  onDelete = (e) => {
    e.stopPropagation()
    Modal.confirm({
      title: '确定要删除该地址吗',
      onConfirm: () => {
        this.props.onDelete(this.props.id)
      },
      confirmText: '确认',
      cancelText: '取消'
    })
  }
}

export { AddressItem }
